module.exports = __webpack_public_path__ + "static/media/v_award.5b51ac56.jpeg";